<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <modal :name="modalName" width="500px" :clickToClose="false" height="320px" @before-open="beforeOpen" @before-close="beforeClose">
        <v-card>
            <v-card-title>
                <span class="headline">포인트</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-0" style="width: 500px; height: 200px;">
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12 class="pa-0">
                            <v-select
                                    :items="pointType"
                                    v-model="item.pointType"
                                    label="종류"
                                    item-text="text"
                                    item-value="state"
                            ></v-select>
                        </v-flex>
                        <v-text-field
                                label="포인트 금액"
                                v-model="item.pointAmt"
                                mask="######"
                        ></v-text-field>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer>
                </v-spacer>
                <v-btn color="blue darken-1" flat @click="savePoint">저장</v-btn>
                <v-btn color="blue darken-1" flat @click="closeModal">닫기</v-btn>
            </v-card-actions>
        </v-card>
    </modal>
</template>

<script>
    import PointType from '@/api/pointType';

    export default {
        components: {},
        data : function() {
            return {
                userIds: [],
                item: {},
                pointType: PointType
            }
        },
        props : {
            modalName: {
                required: false,
                default: 'modal-point',
            }
        },
        mounted () {

        },
        methods: {
            beforeOpen (e) {
                if(e.params.userIds) {
                    this.userIds = e.params.userIds;
                }

                console.log(this.userIds);
            },
            beforeClose () {
                this.clearModalData();
            },
            clearModalData() {
                this.userIds = [];
                this.item = {};
            },
            closeModal () {
                this.beforeClose();
                this.$modal.hide(this.modalName);
            },
            savePoint () {
                if(!this.validate()) return;
                if(!confirm('포인트를 저장하시겠습니까?')) return;

                this.item.method = 'createPointPassenger';

                this.item.userIds = this.userIds;

                this.$store.dispatch('banbanAPI', this.item)
                    .then(({ data }) => {
                        top.getApp.progress.dialog = false;

                        if(data.errorCode) {
                            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                            return;
                        }

                        alert('저장이 완료되었습니다.');
                        this.closeModal();
                    })
                    .catch((error) => {
                        if (top.getApp.commonError == null) {
                            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                        }
                        top.getApp.commonError = null;
                        top.getApp.progress.dialog = false;
                    });
            },
            validate () {
                if(this.userIds.length < 1) {
                    alert('포인트 처리할 유저가 존재하지 않습니다.');
                    return false;
                }
                if(!this.item.pointType) {
                    alert('포인트 종류를 선택해 주세요.');
                    return false;
                }
                if(!this.item.pointAmt || this.item.pointAmt < 1) {
                    alert('포인트 금액을 정확하게 입력해 주세요.');
                    return false;
                }
                return true;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/modal/point/modal-point.vue